import { render } from "./AddSingleTariffComponent.vue?vue&type=template&id=ad93c636&scoped=true"
import script from "./AddSingleTariffComponent.vue?vue&type=script&lang=js"
export * from "./AddSingleTariffComponent.vue?vue&type=script&lang=js"

import "./AddSingleTariffComponent.vue?vue&type=style&index=0&id=ad93c636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad93c636"]])

export default __exports__